import { ChangeDetectionStrategy, Component, input, signal, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { FileFolderNode, FileTreeComponent } from '../file-tree/file-tree.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
// prettier-ignore
import {
    faFolder,
    faGear,
    faDatabase,
    faMessageDollar,
    faEye,
    faClock,
    faLock,
    faDiagramProject,
    faSitemap,
    faUserUnlock,
    faBug,
    faBars,
    faListCheck,
    faClipboardListCheck,
    faChartSimple,
    faBookBookmark,
    faThList,
    faQuestionCircle,
    faToggleOn,
    faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { RoutingService } from '@r1-compass-library/services';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';

export type SidenavLink = {
    title: string;
    url: string;
    icon: IconName | 'salesforce'; // Define strings with `as const` so the names resolve statically, like `icon: 'sitemap' as const`
    hasValidationIssue?: boolean;
    sectionKey?: string;
};

@Component({
    selector: 'r1-compass-lib-sidenav',
    // prettier-ignore
    imports: [
        MatSidenavModule, MatButtonModule, MatListModule,
        MatIconModule, MatDividerModule, RouterModule,
        MatSelectModule, FileTreeComponent, FontAwesomeModule,
    ],
    templateUrl: './sidenav.component.html',
    styleUrl: './sidenav.component.scss',
    providers: [MatIconRegistry],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
    protected readonly routingService = inject(RoutingService);

    links = input.required<SidenavLink[]>();
    sidenavFolders = input.required<FileFolderNode[]>();
    sidenavMainTitle = input.required<string>();
    showSidenav = input.required<boolean>();
    divisionSettingsDisabled = input.required<boolean>();

    expanded = signal(true);

    faBars = faBars;

    constructor() {
        const library = inject(FaIconLibrary);

        // Add an icon to the library for convenient access in other components
        // prettier-ignore
        library.addIcons(
            faFolder, faGear, faDatabase, faMessageDollar, faEye, faClock, faLock,
            faDiagramProject, faSitemap, faUserUnlock, faBug, faBars, faListCheck, faClipboardListCheck,
            faChartSimple, faBookBookmark, faThList, faQuestionCircle, faSalesforce, faToggleOn, faTriangleExclamation
        );
    }
}
